import request from '@/utils/request'

// 获取 table 数据
export const getTableData = params =>
  request.post('/customer-api/ar/page', params)

export const getTableData2 = params =>
  request.post('/customer-api/ar/pageAll', params)

// 下载
export const download = params =>
  request.post('/customer-api/ar/export', params, { responseType: 'blob' })

export const getByDate = companyId =>
  request.get(`/customer-api/ar/getLineChartByDay/${companyId}`)

export const getByMonth = companyId =>
  request.get(`/customer-api/ar/getLineChartByMonthOne/${companyId}`)
